import { FormData } from 'evidencna-aplikacia-frontend-ts-axios';
import { ClientResponse } from '../model/ClientResponse';
import { FormDataResponse } from '../model/sprievodnyDokument/FormDataResponse';
import {
  fetchLegislativnyMaterialDetail,
} from '../client/legislativnyMaterial/legislativnyMaterialDetailClient';
import PracovnyKrokEnum from '../model/pracovnyKrok/PracovnyKrokEnum';
import {
  getObalMaterialuDetail,
} from '../client/external/evidencnaaplikacia/obalMaterialuFormDataClient';
import Uuid from '../model/Uuid';

export default async (
  type: string,
  year: number,
  index: number,
  sprievodnyDokumentUuid: Uuid,
  headers?: object,
): Promise<ClientResponse<FormDataResponse<FormData>>> => {
  const {
    data: materialDetail,
  } = await fetchLegislativnyMaterialDetail(
    type,
    year,
    index,
    PracovnyKrokEnum.SPRIEVODNY_DOKUMENT_FUNCTION,
    headers,
  );

  const {
    data: formData,
    responseCode,
  } = await getObalMaterialuDetail(materialDetail.uuid, sprievodnyDokumentUuid, headers);

  return {
    data: { formData, materialDetail },
    responseCode,
  };
};
